var installedModules = {};
var moduleToHandlerMapping = {
	3732: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(6540); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	1995: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(4848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	865: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(6417), __webpack_require__.e(1034), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(6715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	1924: {
		getter: function() { return __webpack_require__.e(8606).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	3224: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(1106), __webpack_require__.e(7182)]).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	9914: {
		getter: function() { return Promise.all([__webpack_require__.e(6417), __webpack_require__.e(8122), __webpack_require__.e(6066)]).then(function() { return function() { return __webpack_require__(514); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	8006: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(9965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	4178: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	8712: {
		getter: function() { return __webpack_require__.e(2140).then(function() { return function() { return __webpack_require__(9759); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	7733: {
		getter: function() { return __webpack_require__.e(8501).then(function() { return function() { return __webpack_require__(882); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	7070: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	8122: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(961); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	5534: {
		getter: function() { return Promise.all([__webpack_require__.e(2586), __webpack_require__.e(8486), __webpack_require__.e(3732), __webpack_require__.e(1995), __webpack_require__.e(4301)]).then(function() { return function() { return __webpack_require__(4301); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.102",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-auth-react",
	},
	1682: {
		getter: function() { return Promise.all([__webpack_require__.e(2331), __webpack_require__.e(5371)]).then(function() { return function() { return __webpack_require__(7752); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.30",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-react-utils",
	},
	5464: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(1106), __webpack_require__.e(2581)]).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	3780: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	4025: {
		getter: function() { return Promise.all([__webpack_require__.e(2331), __webpack_require__.e(7141)]).then(function() { return function() { return __webpack_require__(9522); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.31",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-react-utils",
	},
	913: {
		getter: function() { return Promise.all([__webpack_require__.e(4036), __webpack_require__.e(2331), __webpack_require__.e(8122), __webpack_require__.e(4598)]).then(function() { return function() { return __webpack_require__(2217); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.30",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-react-utils",
	},
	3292: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	}
};
var initialConsumes = [3732,1995,865,1924,3224,9914,8006,4178,8712,7733,3732,7070,8122,1995,5534,1682,5464,865,3780,4025,3292];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"636": [
		1995,
		5534,
		1682,
		5464,
		865,
		3780,
		4025
	],
	"865": [
		865
	],
	"1682": [
		1682
	],
	"1995": [
		1995
	],
	"3292": [
		3292
	],
	"3732": [
		3732
	],
	"4301": [
		913
	],
	"5527": [
		1924,
		3224,
		9914,
		8006,
		4178,
		8712,
		7733
	],
	"5534": [
		5534
	],
	"5935": [
		5464,
		3780,
		4025
	],
	"8122": [
		8122
	],
	"8792": [
		3732,
		7070,
		8122
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}